import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { visitorLogAPI } from '../api';
import { FaUsers, FaHome, FaUserTie } from 'react-icons/fa';
import VisitorLogForm from './VisitorLogForm';
import ResidentFeedbackForm from './ResidentFeedbackForm';
import StaffFeedbackForm from './StaffFeedbackForm';

const LogFormRouter = () => {
  const { homeId } = useParams();
  const [homeDetails, setHomeDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formType, setFormType] = useState(null);

  useEffect(() => {
    loadHomeDetails();
  }, [homeId]);

  const loadHomeDetails = async () => {
    try {
      const response = await visitorLogAPI.getHomeDetails(homeId);
      setHomeDetails(response.data);
    } catch (error) {
      console.error('Error loading home details');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="log-form-container">
        <div className="loading"><div className="spinner"></div></div>
      </div>
    );
  }

  if (!homeDetails) {
    return (
      <div className="log-form-container">
        <div className="log-form-card">
          <div className="empty-state">
            <div className="empty-icon"><FaHome /></div>
            <h3 className="empty-title">Home Not Found</h3>
            <p className="empty-text">This home does not exist or is inactive</p>
          </div>
        </div>
      </div>
    );
  }

  if (!formType) {
    return (
      <div className="log-form-container">
        <div className="log-form-card">
          <div className="log-form-header">
            <img src="/littleFeetlogo.webp" alt="Little Feet Homes" className="log-form-logo" />
            <h1 className="log-form-title">Welcome to {homeDetails.title}</h1>
            <p className="log-form-subtitle">Please select your role</p>
          </div>
          <div className="form-type-selection">
            <div className="form-type-buttons">
              <div className="form-type-button" onClick={() => setFormType('visitor')}>
                <div className="form-type-icon"><FaUsers /></div>
                <div className="form-type-label">Visitor / Parent</div>
              </div>
              <div className="form-type-button" onClick={() => setFormType('resident')}>
                <div className="form-type-icon"><FaHome /></div>
                <div className="form-type-label">Resident</div>
              </div>
              <div className="form-type-button" onClick={() => setFormType('staff')}>
                <div className="form-type-icon"><FaUserTie /></div>
                <div className="form-type-label">Staff Member</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return formType === 'visitor' ? (
    <VisitorLogForm homeId={homeId} homeDetails={homeDetails} onBack={() => setFormType(null)} />
  ) : formType === 'resident' ? (
    <ResidentFeedbackForm homeId={homeId} homeDetails={homeDetails} onBack={() => setFormType(null)} />
  ) : (
    <StaffFeedbackForm homeId={homeId} homeDetails={homeDetails} onBack={() => setFormType(null)} />
  );
};

export default LogFormRouter;